import HTML5 from "react-dnd-html5-backend";
import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import TouchBackend from "react-dnd-touch-backend";

const MyComponent = ({ children }) => children;
let backend = HTML5Backend;
let touchOptions = {
  scrollAngleRanges: [
    { start: 30, end: 150 },
    { start: 210, end: 330 },
  ],
};
if (window.innerWidth <= "600") {
  backend = TouchBackend(touchOptions);
}

export default DragDropContext(backend)(MyComponent);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/HtmlDragDropContext/index.js